import { j as s } from "../../../../jsx-runtime.BREq8dyb.js";
import { Button as e } from "@mui/joy";
import { memo as d, Fragment as l } from "react";
import { c } from "../../../../react-hook-form.Du3weLRK.js";
const a = {
  children: "Cancel"
}, r = {
  children: "Submit"
}, u = d(({
  resetButtonProps: n = a,
  submitButtonProps: m = r,
  ...o
}) => {
  const {
    disabled: i,
    isSubmitting: t
  } = c();
  return /* @__PURE__ */ s.jsxs(l, { children: [
    /* @__PURE__ */ s.jsx(e, { ...o, ...a, ...n, disabled: i || t, type: "reset" }),
    /* @__PURE__ */ s.jsx(e, { ...o, ...r, ...m, color: "primary", disabled: i || t, loading: t, loadingPosition: "start", type: "submit", variant: "solid" })
  ] });
});
u.displayName = "DqDatasetSyncActions";
export {
  u as default
};
//# sourceMappingURL=DqDatasetSyncActions.js.map
